/**
 * 创建人：D
 * 时间：2019-03-27
 * 描述：将数据保存到sessionStorage 里面
 * 更新记录:
 */
import { Injectable } from '@angular/core';

/**
 * 获取浏览器缓存
 */
@Injectable()
export class SwJwtService {

  /**
   * @ignore
   */
  constructor() { }


  /**
   * 获取session token的值中的数据
   * @param key  获取的key值
   */
  getToken(key:string){
    return localStorage.getItem(key);

  }
  /**
   * 获取loca token 的值
   * @param key  获取的key值
   */
  getlocaToken(key:string){
    return localStorage.getItem(key)
  }


  /**
   * localStorage 的值
   * @param Key  写入的key值
   * @param value  写入的value数据
   */
  setlocaToken(Key:string,value:any){
    localStorage.setItem(Key,value);
  }
  /**
   * 添加sessionStorage的值
   * @param Key 写入的key值
   * @param value  写入的value数据
   */
  setToKen(Key:string,value:any){
    localStorage.setItem(Key,value);
 }

  /**
   * 删除token
   * @param Key 删除的key
   */
  removeItem(Key:string){
    sessionStorage.removeItem(Key);
    localStorage.removeItem(Key);
  }

  /**
   * 清空token
   */
  clear(){
    sessionStorage.clear();
    localStorage.clear();
  }
}
